import { Propriedade } from '@common/apis/simulated-debt/types';
import { DebtProperty } from '@common/apis/sorting-debt/types';

const usedProperty = 'DEBT_LOGO';

// :(

export function formatPartnerName(
  props: DebtProperty[] | Propriedade[] | any
) {
  const safeProps = (props || []) as any[];
  const logoProp = safeProps?.find(
    (prop) => (prop?.key || prop?.chave) === usedProperty
  );

  if (logoProp) {
    const strValue = logoProp?.stringValue || logoProp?.valorString;

    return strValue?.charAt(0)?.toUpperCase() + strValue?.slice(1);
  }
}
